import { useEffect } from "react";
import { SITE_URL } from "@/utils/siteUrl";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryButtons from "./components/CategoryButtons";
import WhatIsSection from "./components/WhatIsSection";
import FeatureCards from "./components/FeatureCards";
import ComparisonTable from "./components/ComparisonTable";
import SearchIntentSection from "./components/SearchIntentSection";
import ResourcesSection from "./components/ResourcesSection";
import SEOArticlesSection from "./components/SEOArticlesSection";
import SafetySection from "./components/SafetySection";
import FAQSection from "./components/FAQSection";
import ArticleCTA from "./components/ArticleCTA";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Vigorbuy Spreadsheet Guide 2026 | Templates, Reviews, Features & Safety",
        "description": "Discover the complete Vigorbuy Spreadsheet guide. Learn features, templates, usage tips, comparisons, safety information and expert spreadsheet solutions.",
        "url": `${SITE_URL}/`,
        "mainEntity": {
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "What is Vigorbuy Spreadsheet?", "acceptedAnswer": { "@type": "Answer", "text": "Vigorbuy Spreadsheet is a comprehensive spreadsheet solution for organizing data, managing inventory, tracking products and improving workflow efficiency." } },
            { "@type": "Question", "name": "Is Vigorbuy Spreadsheet safe to use?", "acceptedAnswer": { "@type": "Answer", "text": "Yes, Vigorbuy Spreadsheet is safe when used through official channels. Always verify you are using authentic resources and follow recommended security practices." } },
            { "@type": "Question", "name": "How do I get started with Vigorbuy Spreadsheet?", "acceptedAnswer": { "@type": "Answer", "text": "Getting started is simple. Visit the official website, explore available templates and begin with the beginner-friendly guides." } },
            { "@type": "Question", "name": "What templates are available in Vigorbuy Spreadsheet?", "acceptedAnswer": { "@type": "Answer", "text": "Vigorbuy Spreadsheet offers templates including business management, inventory tracking, product cataloging, sales reports, budget planning and more." } },
            { "@type": "Question", "name": "How does Vigorbuy Spreadsheet compare to Excel or Google Sheets?", "acceptedAnswer": { "@type": "Answer", "text": "Vigorbuy Spreadsheet provides more specialized templates and structured systems compared to traditional spreadsheets, focusing on ready-to-use solutions for business needs." } },
            { "@type": "Question", "name": "Can beginners use Vigorbuy Spreadsheet effectively?", "acceptedAnswer": { "@type": "Answer", "text": "Absolutely. Vigorbuy Spreadsheet is designed with beginners in mind with an intuitive interface, pre-configured templates and comprehensive guides." } }
          ]
        }
      }) }} />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryButtons />
        <WhatIsSection />
        <FeatureCards />
        <ComparisonTable />
        <SearchIntentSection />
        <ResourcesSection />
        <SEOArticlesSection />
        <SafetySection />
        <FAQSection />
        <ArticleCTA />
      </main>
      <Footer />
    </div>
  );
}